






















































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import ordersService from '@/modules/orders/ordersService';
import settings from '@/settings.json';
import notificationService from '@/services/notificationService';
import cCard from '@/components/default/Card.vue';
import { DxLoadPanel } from 'devextreme-vue/load-panel';

import projectsRepository from '@/services/projectsRepository';
import customersRepository from '@/services/customers/customersRepository';
import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';

// import customersRepository from '@/services/customers/customersRepository';
import OrderMailPopup from '@/modules/orders/components/OrderMailPopup.vue';

import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxLabel } from 'devextreme-vue/form';

import { DxDataGrid, DxColumnFixing, DxSearchPanel, DxColumn, DxEditing } from 'devextreme-vue/data-grid';

import { DxRadioGroup, DxTabs } from 'devextreme-vue';
import { EventLogsObjectType } from '@/modules/shared/eventlogs/enums';
import EventLogsTable from '@/modules/shared/eventlogs/components/EventLogsTable.vue';

import { OrderStatus, OrderType } from '@/modules/orders/enums';
import AddArticleToOrderPopup from '@/modules/orders/components/AddArticleToOrderPopup.vue';
import GeneratePurchaseOrderDocumentPopup from '@/modules/orders/components/GeneratePurchaseOrderDocumentPopup.vue';

import SaveBar from '@/modules/shared/savebar/SaveBar.vue';
import PdfViewer from '@/plugins/pdfjs/PdfViewer.vue';
import {
  ArticleCategory,
  ArticleCategoryClient,
  ExportOrderCommand,
  Order,
  OrderLine,
  OrdersClient,
  OrderVm,
  ProgressStatementExportType,
  Settings,
  UpdateOrderLinesCommand,
	Location
} from '@/data/web-api-client';
import ProjectIsOnHoldPopup from '@/components/projects/ProjectIsOnHoldPopup.vue';
import { EntityType, SummaryItem } from '@/components/articles/articleSummaryTable.vue';
import ArticleSummaryTable from '@/components/articles/articleSummaryTable.vue';
import { groupBy } from '@/helpers/Helper';

Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: {
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
    cCard,
    DxDataGrid,
    DxColumn,
    DxEditing,
    OrderMailPopup,
    DxLoadPanel,
    DxTabs,
    EventLogsTable,
    DxColumnFixing,
    DxSearchPanel,
    AddArticleToOrderPopup,
    GeneratePurchaseOrderDocumentPopup,
    SaveBar,
    PdfViewer,
    DxRadioGroup,
    ProjectIsOnHoldPopup,
    ArticleSummaryTable,
  },
})
export default class OrderDetails extends Vue {
  entityType: EntityType = 'Order';

  loading: boolean = false;
  saving: boolean = false;
  data: OrderVm | null = null;
  loadingDocument: boolean = false;
  dirtyDetails: boolean = false;
  dirtyLines: boolean = false;
  navIndex: number = 0;
  order: Order | null = null;
  lines: OrderLine[] = [];
  document: any = null;
  documentAsUrl: string = '';
  documentEditUrl: string = '';
  pdfSize: number = 450;
  disabled: boolean | undefined = false;
  selectedExportType = ProgressStatementExportType.Standard;
  progressStatementExportTypeEnum = ProgressStatementExportType;
  documentSettings: any = {
    language: null,
    groupArticlesByCategory: false,
  };
  languages: string[] = [];
  templates: any[] = [];

  projectNumber: string = '';
  projectLocation: Location | null= null;
  ordersClient: OrdersClient = new OrdersClient(undefined, this.$axios);
  public articleCategories: ArticleCategory[] = [];

  declare currency: any;

  async mounted() {
    this.pdfSize = window.innerHeight - 275;
    this.languages = this.$store.getters['catalogs/list']('Languages')?.values ?? [];
    await this.loadData();
  }

  async loadData() {
    try {
      this.loading = true;
      this.templates = (await ordersService.getTemplates()).data;
      this.articleCategories = await new ArticleCategoryClient(undefined, this.$axios).get();

      const order = await this.ordersClient.get(this.$route.params.id);

      this.data = order;
      this.order = Object.assign({}, this.data.order);
      this.lines = this.data!.order!.lines!.slice();
      this.disabled = this.data.projectIsOnHold;
      this.projectNumber = this.data.projectNumber!;
      this.projectLocation = this.data.projectLocation!;
    } catch (err) {
      notificationService.failedToLoad();
    } finally {
      setTimeout(() => {
        this.loading = false;

        if (this.$route.query.checkProjectOnHold === 'true' && this.data?.projectIsOnHold) {
          this.projectIsOnHoldPopup.show();
        }
      }, 200);
    }
  }

  async generateDocument() {
    try {
      const validationResult = (this.$refs.GeneratePurchaseOrderDocumentPopupForm as any).instance.validate();
      if (validationResult.isValid) {
        this.saving = true;

        await ordersService.generateDocument({
          id: this.order!.id!,
          template: this.documentSettings.template,
          language: this.documentSettings.language,
          groupArticlesByCategory: this.documentSettings.groupArticlesByCategory,
        });
        await this.loadDocument();
      } else {
        notificationService.invalidForm();
      }
    } finally {
      this.saving = false;
    }
  }

  async loadDocument() {
    try {
      this.loadingDocument = true;
      this.document = (await ordersService.download(this.$route.params.id)).data;
      this.documentAsUrl = window.URL.createObjectURL(this.document);
      this.documentEditUrl = (await ordersService.getDocumentUrl(this.$route.params.id)).data;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loadingDocument = false;
    }
  }

  async downloadExport($event: any) {
    $event.preventDefault();
    $event.stopPropagation();

    try {
      const fileResponse = await this.ordersClient.export(
        new ExportOrderCommand({
          // projectId: this!.order!.projectId!,
          currentOrder: this.order!.documentNumber,
        })
      );
      const blob = fileResponse.data;
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.download = fileResponse.fileName ?? 'download';
      anchor.href = url;
      anchor.click();
    } catch (err) {
      notificationService.showAxiosError(err);
    }
  }

  openMailDialog() {
    (this.$refs.OrderMailPopup as OrderMailPopup).open();
  }

  async save() {
    try {
      this.saving = true;
      if (this.dirtyDetails && this.order) {
        await this.ordersClient.put(this.order.id!, this.order);
        this.dirtyDetails = false;
      }
      if (this.dirtyLines && this.order) {
        await this.ordersClient.putLines(this.order.id!, {
          id: this.$route.params.id,
          lines: this.lines,
        } as UpdateOrderLinesCommand);
        this.dirtyLines = false;
      }
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  async goodsReceived() {
    try {
      if (this.order) {
        await this.ordersClient.goodsReceived(this.order.id!);
        (this.order as any).goodsReceived = true;
      }
    } catch (err) {
      notificationService.showAxiosError(err);
    }
  }

  async invoiceReceived() {
    try {
      if (this.order) {
        await this.ordersClient.invoiceReceived(this.order.id!);
        (this.order as any).invoiceReceived = true;
      }
    } catch (err) {
      notificationService.showAxiosError(err);
    }
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.dirtyLines || this.dirtyDetails) {
      if (confirm('Er zijn onopgeslagen wijzigingen. Bent u zeker dat u wenst te veranderen van pagina?')) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }

  toolbarPreparing(e: any) {
    const self = this;
    e.toolbarOptions.items.push({
      location: 'before',
      widget: 'dxButton',
      options: {
        icon: 'fas fa-plus',
        text: 'Code',
        stylingMode: 'outlined',
        type: 'success',
        disabled: this.disabled,
        onClick: () => {
          if (self.order && self.order.projectId && self.order.supplierId && self.order.projectId !== '' && self.order.supplierId !== '') {
            (self.$refs.AddArticleToOrderPopup as AddArticleToOrderPopup).Open();
          } else {
            notificationService.showErrorMessage('Gelieve eerst een project & leverancier te kiezen');
          }
        },
      },
    });
  }

  addLine(e: OrderLine) {
    const existingLine = this.lines.find((l) => l.description == e.description && l.measuringUnit == e.measuringUnit);

    if (existingLine) {
      existingLine.quantity! += e.quantity!;

      return;
    }

    this.lines.push(e);
  }

  sendMail() {
    (this.$refs.OrderMailPopup as OrderMailPopup).open();
  }

  navigateToTabWithKey(key: string) {
    this.navIndex = this.getNavbarIndexWithKey(key);
  }

  getNavbarIndexWithKey(key: string) {
    const navbarItem = this.navbarItems.find((nbi) => nbi.key == key);

    if (!navbarItem) {
      throw Error(`No navbar item with key ${key}`);
    }

    return this.navbarItems.indexOf(navbarItem);
  }

  get codeSummary(): SummaryItem[] {
    const summaryByCategories = this.settings.summaryInCategories;
    let result: SummaryItem[] = [];

    if (!this.order) {
      return result;
    }

    if (summaryByCategories) {
      const allLines = this.order.lines!;

      const groupedLinesByCategory: Map<string, OrderLine[]> = groupBy(allLines, 'articleCategoryId');

      for (const [key, values] of groupedLinesByCategory) {
        var groupedLines: Map<string, OrderLine[]> = groupBy(values, 'description');
        for (const [articleId, lines] of groupedLines) {
          if (lines.length == 0) continue;

          let line = lines[0];

          const quantitySum = lines.reduce((a: number, { quantity }) => a + quantity!, 0);
          const totalSum = lines.reduce((a: number, { totalPrice }) => a + totalPrice!, 0);

          const resultIndex = result.findIndex((o) => o.articleId === line.supplierReference && o.description === line.description);
          if (resultIndex === -1) {
            result.push({
              articleId: line.supplierReference!,
              description: line.description!,
              quantity: quantitySum,
              unitPrice: totalSum!,
              articleCategoryId: line.articleCategoryId!,
            });
          } else {
            result[resultIndex].quantity += quantitySum;
            result[resultIndex].unitPrice += totalSum!;
          }
        }
      }

      result.forEach((resultItem) => {
        resultItem.unitPrice = resultItem.unitPrice / resultItem.quantity;
      });

      return result;
    }

    // summary not grouped by categories
    for (const line of this.order.lines!) {
      if (line.supplierReference && line.supplierReference !== '' && line.quantity && line.totalPrice) {
        const resultIndex = result.findIndex((o) => o.articleId === line.supplierReference && o.description === line.description);
        if (resultIndex === -1) {
          result.push({
            articleId: line.supplierReference,
            description: line.description!,
            quantity: line.quantity!,
            unitPrice: line.totalPrice!,
            articleCategoryId: line.articleCategoryId!,
          });
        } else {
          result[resultIndex].quantity += line.quantity;
          result[resultIndex].unitPrice += line.totalPrice;
        }
      }
    }

    result.forEach((resultItem) => {
      resultItem.unitPrice = resultItem.unitPrice / resultItem.quantity;
    });

    return result;
  }

  get settings(): Settings {
    return this.$store.getters['settings/data'];
  }

  get maxDocumentHeight() {
    const value = window.innerHeight - 500;

    if (value < 500) {
      return {
        height: '500px',
        width: '100%',
        minHeight: '500px',
      };
    }

    return {
      height: value + 'px',
      width: '100%',
      minHeight: '500px',
    };
  }

  get statusOptions() {
    return {
      items: [
        { value: OrderStatus.Draft, text: 'Klad' },
        { value: OrderStatus.Open, text: 'Open' },
        { value: OrderStatus.Send, text: 'Verstuurd' },
        { value: OrderStatus.Completed, text: 'Afgerond' },
      ],
      valueExpr: 'value',
      displayExpr: 'text',
    };
  }

  get navbarItems() {
    let navbar = [
      { icon: 'fas fa-info-circle', text: 'Basis info', key: 'basicInfo', visible: true },
      { icon: 'fas fa-info-circle', text: 'Samenvatting', key: 'summary', visible: true },
      { icon: 'fas fa-file-pdf', text: 'Document', key: 'document', visible: true },
      { icon: 'fas fa-history', text: 'Geschiedenis', key: 'history', visible: true },
    ];

    if (!this.order || this.order.type != 1) {
      navbar.find((nb) => nb.key == 'summary')!.visible = false;
    }

    return navbar;
  }

  get historyConfig(): IEventLogQuery {
    return {
      objectId: this.$route.params.id,
      type: EventLogsObjectType.Order,
    };
  }

  get totalExcl() {
    if (!this.lines || this.lines.length === 0) {
      return 0;
    }

    let total = 0;

    this.lines.forEach((line) => {
      total += line!.quantity! * line!.unitPrice!;
    });

    return total;
  }

  get projectsOptions() {
    const self = this;
    return {
      dataSource: new DataSource({
        store: new dxCustomStore({
          key: 'id',
          load: async (loadOptions: any) => {
            if (Array.isArray(loadOptions.filter) && loadOptions.filter.length > 1 && loadOptions.filter[0] === 'id') {
              return {
                data: [],
                totalCount: 0,
              };
            }

            if (loadOptions.searchExpr && loadOptions.searchValue && loadOptions.searchOperation) {
              loadOptions.filter = [loadOptions.searchExpr, loadOptions.searchOperation, loadOptions.searchValue];
            }

            const result = await projectsRepository.lookup(loadOptions);

            return {
              data: result.data.data,
              totalCount: result.data.totalCount,
            };
          },
          byKey: async (val: any) => {
            return projectsRepository.getSingle(val).then((result: any) => {
              return result.data;
            });
          },
        }),
        paginate: true,
      }),
      valueExpr: 'id',
      displayExpr: 'name',
      searchExpr: 'name',
      searchEnabled: true,
      showClearButton: true,
    };
  }

  get supplierOptions() {
    return {
      dataSource: new DataSource({
        store: new dxCustomStore({
          load: async (loadOptions: any) => {
            const result = await customersRepository.get(loadOptions);
            return {
              data: result.data,
            };
          },
          byKey: (val: any) => {
            return customersRepository.getSingle(val).then((result: any) => {
              return result.data;
            });
          },
        }),
        paginate: true,
      }),
      displayExpr: 'displayName',
      valueExpr: 'id',
      searchEnabled: true,
    };
  }

  get measuringunitOptions() {
    const measuringUnits = this.$store.getters['measuringUnits/data'];

    return { items: measuringUnits ?? [] };
  }

  get exportOptions() {
    return [
      {
        id: ProgressStatementExportType.Standard,
        value: 'Bestelbon PDF',
      },
      {
        id: ProgressStatementExportType.Excel,
        value: 'Bestelbon Excel',
      },
    ];
  }

  get lineColumns() {
    const self = this;
    return [
      {
        dataField: 'description',
        caption: 'Beschrijving',
        validationRules: [
          {
            type: 'required',
            message: 'Veld is verplicht',
          },
        ],
        cellTemplate: (cellElement: any, cellInfo: any) => {
          if (!cellInfo.data.metaData) {
            return $(cellElement).append(`${cellInfo.data.description}`);
          }

          if (cellInfo.data.metaData.articleId && cellInfo.data.metaData.articleId !== '') {
            return $(cellElement).append(`<i class='fas fa-shopping-basket'></i> ${cellInfo.data.description}`);
          }

          if (cellInfo.data.metaData.rawMaterialId && cellInfo.data.metaData.rawMaterialId !== '') {
            return $(cellElement).append(`<i class='fas fa-table'></i> ${cellInfo.data.description}`);
          }

          return $(cellElement).append(`${cellInfo.data.description}`);
        },
      },
      {
        dataField: 'quantity',
        caption: 'Hoeveelheid',
        alignment: 'left',
        dataType: 'number',
        calculateCellValue(value: any) {
          if (value.quantity) {
            return Math.round(value.quantity * 1000) / 1000;
          }
          return 0;
        },
        validationRules: [
          {
            type: 'required',
            message: 'Veld is verplicht',
          },
        ],
      },
      {
        dataField: 'measuringUnit',
        caption: 'Meeteenh.',
        lookup: {
          dataSource: this.measuringunitOptions.items,
        },
        validationRules: [
          {
            type: 'required',
            message: 'Veld is verplicht',
          },
        ],
      },
      {
        dataField: 'unitPrice',
        caption: 'Stukprijs',
        dataType: 'number',
        alignment: 'left',
        format: {
          type: 'currency',
          precision: 2,
        },
        validationRules: [
          {
            type: 'required',
            message: 'Veld is verplicht',
          },
        ],
      },
      {
        caption: 'Totaal',
        dataType: 'number',
        alignment: 'left',
        format: {
          type: 'currency',
          precision: 2,
        },
        calculateCellValue: (e: any) => {
          return e.unitPrice * e.quantity;
        },
      },
      {
        dataField: 'remarks',
        caption: 'Opmerkingen',
        dataType: 'text',
        visible: false,
      },
      {
        type: 'buttons',
        buttons: [
          {
            hint: 'Opmerking',
            icon: 'fas fa-comment-dots',
            visible(e: any) {
              return !e.row.isEditing && !e.row.data.isCompleted && !self.disabled;
            },
            // onClick: this.updateNotes,
          },
          'edit',
          'delete',
        ],
      },
    ];
  }

  get projectIsOnHoldPopup() {
    return this.$refs.projectIsOnHoldPopup as ProjectIsOnHoldPopup;
  }

  get languageOptions() {
    const items = this.languages.map((l) => ({
      value: l,
      text: l,
    }));

    return {
      dataSource: items,
      displayExpr: 'text',
      valueExpr: 'value',
      filterExpr: 'value',
      showClearButton: 'true',
    };
  }

  get templateOptions() {
    const self = this;
    return {
      dataSource: this.templates,
      valueExpr: 'name',
      displayExpr: 'name',
      searchExpr: 'name',
      searchEnabled: true,
      showClearButton: true,
    };
  }

  get documentFields() {
    return [
      {
        itemType: 'simple',
        dataField: 'template',
        editorOptions: this.templateOptions,
        editorType: 'dxSelectBox',
        label: {
          text: 'template',
        },
        validationRules: [{ type: 'required', message: 'Veld is verplicht' }],
      },
      {
        itemType: 'simple',
        dataField: 'language',
        editorOptions: this.languageOptions,
        editorType: 'dxSelectBox',
        label: {
          text: 'taal',
        },
      },
    ];
  }

  @Watch('lines', { deep: true })
  onLinesChange() {
    if (!this.loading) {
      this.dirtyLines = true;
    }
  }
  @Watch('order', { deep: true })
  onOrderChange() {
    if (!this.loading) {
      this.dirtyDetails = true;
    }
  }

  @Watch('navIndex')
  onNavIndexChange() {
    if (this.navIndex === this.getNavbarIndexWithKey('document')) {
      if (this.order && (!this.order.driveKey || this.order.driveKey === '')) {
        this.generateDocument();
      } else {
        this.loadDocument();
      }
    }
  }
}
